import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import GroupInviteRequest from 'models/groups/GroupInviteRequest';
import GroupInviteMemberRequest from 'models/groups/GroupInviteMemberRequest';
import ModalPopupView from 'views/main/Modal/ModalPopupView';
import ModalWarningView from 'views/main/Modal/ModalWarningView';
import PrivacyAlertModalView from 'views/privacy/PrivacyAlertModalView';
import PrivacyAlertView from 'views/privacy/PrivacyAlertView';
import JoinGroupConsentView from 'views/groups/modals/JoinGroupConsentView';
import NavigationUtil from 'utils/NavigationUtil';
import DateFormatter from 'utils/date/DateFormatter';
import DateParser from 'utils/date/DateParser';
import templateHtml from 'templates/notification/PendingGroupRequestItemView.html';
import GroupDispatcher from 'events/GroupDispatcher';
import { groupRequestErrors } from 'utils/groups/GroupsUtil';
import i18next from 'config/i18next';

// utils -- userSocialProfileImage
import profileImageHelperV2 from 'utils/userSocialProfileImage/profileImageHelperV2';
import 'utils/userSocialProfileImage/profileImageTypeDefsV2';

i18next.loadNamespaces(['notification']);

var Events = {
    ON_NAVIGATION: 'ON_NAVIGATION'
};

var PendingGroupRequestItemView = Backbone.View.extend({
    events: {
        'click .confirm': 'onConfirmButtonClicked',
        'click .ignore': 'onIgnoreButtonClicked',
        'click .js-select-group': 'onGroupClicked',
        'click .js-select-user': 'onUserClicked'
    },

    initialize: function(args) {
        this.template = _.template(templateHtml);
        this.pendingConnection = args.pendingConnection;
        this.userProfile = args.userProfile;
        this.userPreferences = args.userPreferences;
        this.groupInviteSpammingDays = args.groupInviteSpammingDays;

        this.profileInfos = args.profileInfos;
    },

    render: function() {
        const { displayName, fullName, groupName, groupId, createDate, groupMemberRequestId } = this.pendingConnection;
        const timeStamp = createDate && DateFormatter.formatRelativeTime(DateParser.parseISOUTC(createDate));
        const profileUrl = NavigationUtil.url('/profile/' + displayName);
        const groupUrl = NavigationUtil.url('/group/' + groupId);
        const connectionName = fullName || displayName;
        const groupJoinRequestString = i18next.t('notification:group.request', {
            0: connectionName,
            1: groupName,
            2: profileUrl,
            3: groupUrl
        });
        const groupAdminInviteString = i18next.t('notification:group_admin_invite', {
            0: connectionName,
            1: profileUrl,
            2: groupName,
            3: groupUrl
        });

        this.$el.html(
            this.template({
                Localizer,
                timeStamp,
                profileUrl,
                groupRequestString: groupMemberRequestId ? groupJoinRequestString : groupAdminInviteString,
                imageUrl: this.getProfileImageUrl()
            })
        );
        this.$('img.avatar').on('error', (evt) => {
            evt.target.src = profileImageHelperV2.getDefaultProfileImage();
            this.$('img.avatar').css('border-radius', '');
        });
    },

    onConfirmButtonClicked: function(e) {
        e.preventDefault();

        var joinGroupConsentView = new JoinGroupConsentView(),
            that = this,
            modalView = new ModalPopupView({
                view: joinGroupConsentView,
                modalTitle: Localizer.localize('data_and_privacy'),
                cancelTextKey: 'button_cancel',
                confirmationTextKey: 'ok',
                onSaveButtonClicked: function() {
                    setTimeout(that.acceptRequest.bind(that), 400);
                    this.close();
                }
            });

        modalView.render();
    },

    acceptRequest: function() {
        var that = this;

        if (this.pendingConnection.groupInviteId) {
            var groupInviteRequest = new GroupInviteRequest({
                userGroupId: this.pendingConnection.groupId,
                groupInviteId: this.pendingConnection.groupInviteId
            });

            groupInviteRequest.save(groupInviteRequest.attributes, {
                success: (model, response) => {
                    that.enableMessages(true);
                    if (!response) {
                        GroupDispatcher.trigger(
                            GroupDispatcher.Events.ON_GROUP_REQUEST_ERROR,
                            groupRequestErrors.invitationCancelled
                        );
                    }
                },
                error: (model, response) => {
                    if (response && response.status === 404) {
                        GroupDispatcher.trigger(
                            GroupDispatcher.Events.ON_GROUP_REQUEST_ERROR,
                            groupRequestErrors.groupDeleted
                        );
                    }
                }
            });
        } else {
            var groupInviteMemberRequest = new GroupInviteMemberRequest({
                userGroupId: this.pendingConnection.groupId,
                groupMemberRequestId: this.pendingConnection.groupMemberRequestId
            });

            groupInviteMemberRequest.save(groupInviteMemberRequest.attributes, {
                success: (model, response) => {
                    that.enableMessages(true);
                    if (!response) {
                        GroupDispatcher.trigger(
                            GroupDispatcher.Events.ON_GROUP_REQUEST_ERROR,
                            groupRequestErrors.requestCancelled
                        );
                    }
                },
                error: (model, response) => {
                    if (response && response.status === 404) {
                        GroupDispatcher.trigger(
                            GroupDispatcher.Events.ON_GROUP_REQUEST_ERROR,
                            groupRequestErrors.groupDeleted
                        );
                    } else if (response && response.status === 403) {
                        GroupDispatcher.trigger(
                            GroupDispatcher.Events.ON_GROUP_REQUEST_ERROR,
                            groupRequestErrors.acceptRequestNoPermission
                        );
                    }
                }
            });
        }

        this.privacyAlertView = new PrivacyAlertView({
            requestType: 'group'
        });

        this.privacyAlertView.on(PrivacyAlertView.Events.Closed, this.closeModal, this);
        this.privacyAlertView.on(PrivacyAlertView.Events.Ready, this.openModal, this);
    },

    openModal: function() {
        if (this.privacyAlertView.getDisplayModal()) {
            this.modalView = new PrivacyAlertModalView({
                view: this.privacyAlertView,
                showFooter: true,
                modalTitle: Localizer.localize('privacy.alert.heading')
            });

            this.modalView.on(PrivacyAlertModalView.Events.ON_SAVE, this.onSavePrivacyClicked, this);
            this.modalView.render();
        }
    },

    closeModal: function() {
        this.modalView.close();
    },

    onSavePrivacyClicked: function() {
        this.privacyAlertView.onSaveClicked();
    },

    onIgnoreButtonClicked: function(e) {
        e.preventDefault();

        if (this.pendingConnection.groupVisibility === 'HIDDEN') {
            const message =
                this.groupInviteSpammingDays > 1
                    ? Localizer.localize('confirm_delete_invitation_dialog_desc_n_days', this.groupInviteSpammingDays)
                    : Localizer.localize('confirm_delete_invitation_dialog_desc_1_day');

            this.modalConfirmationView = new ModalWarningView({
                modalTitle: Localizer.localize('confirm_delete_invitation_dialog_title'),
                message,
                htmlFormat: true,
                confirmationTextKey: 'button_delete',
                cancelTextKey: 'button_cancel',
                onSaveButtonClicked: () => {
                    this.modalConfirmationView.close();
                    this.processIgnoreRequest();
                }
            });
            this.modalConfirmationView.render();
        } else {
            this.processIgnoreRequest();
        }
    },

    processIgnoreRequest: function() {
        var that = this;

        if (this.pendingConnection.groupInviteId) {
            var groupInviteRequest = new GroupInviteRequest({
                userGroupId: this.pendingConnection.groupId,
                groupInviteId: this.pendingConnection.groupInviteId
            });

            groupInviteRequest.save(groupInviteRequest.attributes, {
                success: that.enableMessages(false),
                beforeSend: function(xhr) {
                    xhr.setRequestHeader('X-HTTP-Method-Override', 'DELETE');
                }
            });
        } else {
            var groupInviteMemberRequest = new GroupInviteMemberRequest({
                userGroupId: this.pendingConnection.groupId,
                groupMemberRequestId: this.pendingConnection.groupMemberRequestId
            });

            groupInviteMemberRequest.save(groupInviteMemberRequest.attributes, {
                success: that.enableMessages(false),
                beforeSend: function(xhr) {
                    xhr.setRequestHeader('X-HTTP-Method-Override', 'DELETE');
                }
            });
        }
    },

    enableMessages: function(confirm) {
        if (confirm) {
            this.$('.js-confirm-msg').show();
            this.$('.js-ignore-msg').hide();
        } else {
            this.$('.js-confirm-msg').hide();
            this.$('.js-ignore-msg').show();
        }
        this.$('.confirm').hide();
        this.$('.ignore').hide();
    },

    onUserClicked: function(e) {
        var url = '/profile/' + this.pendingConnection.displayName;
        this.trigger(Events.ON_NAVIGATION);
        NavigationUtil.navigate(url, e);
    },

    onGroupClicked: function(e) {
        var url = '/group/' + this.pendingConnection.groupId;
        this.trigger(Events.ON_NAVIGATION);
        NavigationUtil.navigate(url, e);
    },

    getProfileImageUrl: function() {
        const userId = this.pendingConnection?.userProfileId;
        const fallbackUrl = this.pendingConnection?.profileImageUrlSmall;
        /**
         * @type {SimplePublicSocialProfileV2DTO}
         */
        const dto = this.profileInfos?.[userId];
        return profileImageHelperV2.getDtoSmallIconImage(dto, fallbackUrl);
    }
});

PendingGroupRequestItemView.Events = Events;
export default PendingGroupRequestItemView;
